import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page92() {
  useEffect(() => {
    document.title = "Маяк — Страница 91"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page90" />
        <ForwardLink href="/page92" />
      </div>

      <p style={{ textAlign: "right" }}>91.</p>
      <p>МОЛОДОЙ УДАРЯЕТ СНОВА!</p>
      <p>ЩУПАЛЬЦА СЖИМАЮТ...</p>
      <p>МОЛОДОЙ УДАРЯЕТ СНОВА! И СНОВА!!</p>
      <p>СТАРИК КРИЧИТ В УЖАСЕ:</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ТЫ УБИВАЕШЬ МЕНЯ!
      </p>
      <p>Внезапно...</p>
      <p>МОЛОДОЙ смотрит вниз.</p>
      <p>Это СТАРИК. В крови. Скулящий.</p>
      <p>
        Не русалка, не Уинслоу, просто старый, плачущий мужчина,<br/>
        которого МОЛОДОЙ избил до полусмерти.
      </p>
      <p>
        МОЛОДОЙ встает, тяжело дыша. Он натягивает подтяжки.<br/>
        Вытирает пот со лба. СТАРИК лежит неподвижно, просто<br/>
        дышит и издает почти неслышный всхлип.
      </p>
      <p>МОЛОДОЙ опирается на стол.</p>
      <p>Очень, очень длинная пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Лай.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>Лай, мальчик, лай, дружок.</p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>Лай!</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (очень, очень слабо)<br/>
        Гав.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Разве ты никогда раньше не был на море,<br/>
        лай, говорю, лай!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Арф.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Лай, дружок!
      </p>
      <p style={{ textAlign: "right" }}>91.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page90" />
        <ForwardLink href="/page92" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718398/the-lighthouse-script/pb1jgg390lyexpbykuu5.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page92;
